import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-sidenav-social-platforms-block',
  templateUrl: './sidenav-social-platforms-block.component.html',
})
export class SidenavSocialPlatformsBlockComponent {}
